module.exports = __webpack_public_path__ + "img/uniques.5641a574.svg";